import { motion } from "framer-motion";
import { ARTISTS } from "./homeData";
import { SectionHeading } from "./SectionHeading";

const Marquee = () => (
  <div className="relative overflow-hidden py-6 border-y border-white/10 bg-dream-bg" aria-hidden="true">
    <div className="marquee-track flex w-max gap-12">
      {[...ARTISTS, ...ARTISTS].map((a, i) => (
        <span key={i} className="font-heading text-4xl md:text-6xl font-extrabold uppercase whitespace-nowrap text-outline">
          {a.name} <span className="text-dream-violet">✦</span>
        </span>
      ))}
    </div>
  </div>
);

export const ArtistsWall = () => (
  <section className="bg-dream-bg" data-testid="artists-section">
    <Marquee />
    <div className="max-w-7xl mx-auto px-6 py-24 md:py-28">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
        <SectionHeading
          eyebrow="Created at Dream Makers"
          title={<>Artists who&apos;ve<br className="hidden sm:block" /> made it with us.</>}
        />
        <p className="text-white/50 max-w-sm text-sm md:text-base">From chart-climbing rappers to global-streaming producers — this room has heard them first.</p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
        {ARTISTS.map((a, i) => (
          <motion.div
            key={a.name}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.5, delay: (i % 5) * 0.07 }}
            className="group relative aspect-[3/4] rounded-2xl overflow-hidden border border-white/10 hover:border-dream-violet/60 transition-colors"
            data-testid={`artist-${i}`}
          >
            <img src={a.image} alt={a.name} loading="lazy" className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-[transform,filter] duration-700" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/10 to-transparent" />
            <span className="absolute top-3 left-3 font-mono text-[10px] text-white/60 tracking-widest">{String(i + 1).padStart(2, "0")}</span>
            <p className="absolute bottom-0 left-0 right-0 p-4 font-heading font-bold text-white text-base md:text-lg leading-tight" data-testid={`artist-name-${i}`}>{a.name}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
